import React, { useContext, useState } from "react";
import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faArrowRight,
	faChartLine,
	faLeaf,
	faLock,
	faUser,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import AuthContext from "../../context/AuthProvider";
import UserPool from "../../apis/UserPool";
import logo from "../../images/logo.png";
import "../../css/Login.css";

const Login = () => {
	const { completeLogin } = useContext(AuthContext);
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleSubmit = (event) => {
		event.preventDefault();

		const normalizedUsername = username.trim();
		if (!normalizedUsername || !password) {
			toast.error("Enter both username and password");
			return;
		}

		setIsSubmitting(true);

		const user = new CognitoUser({
			Username: normalizedUsername,
			Pool: UserPool,
		});
		const authenticationDetails = new AuthenticationDetails({
			Username: normalizedUsername,
			Password: password,
		});

		user.authenticateUser(authenticationDetails, {
			onSuccess: (session) => {
				completeLogin(session, session.getAccessToken().payload.username);
				setIsSubmitting(false);
			},
			onFailure: (error) => {
				setIsSubmitting(false);
				toast.error(error.message || "Authentication failed");
			},
			newPasswordRequired: () => {
				setIsSubmitting(false);
				toast.info("A new password is required. Contact the platform administrator.");
			},
		});
	};

	return (
		<main className="login-page">
			<section className="login-visual" aria-label="Domus IoT platform overview">
				<div className="login-visual__glow" aria-hidden="true" />
				<img className="login-brand" src={logo} alt="Edison" />
				<div className="login-visual__content">
					<p className="eyebrow">DOMUS IoT PLATFORM</p>
					<h1>Energy and comfort,<br />in one place.</h1>
					<p className="login-visual__lead">
						Monitor production and consumption, coordinate connected devices and
						keep the home energy flow under control.
					</p>
					<div className="login-feature-list">
						<div><FontAwesomeIcon icon={faChartLine} /><span>Live energy overview</span></div>
						<div><FontAwesomeIcon icon={faLeaf} /><span>Smart optimization rules</span></div>
					</div>
				</div>
				<p className="login-visual__footer">Edison Domus · Connected home laboratory</p>
			</section>

			<section className="login-panel">
				<div className="login-card">
					<div className="login-card__header">
						<span className="login-card__mark"><FontAwesomeIcon icon={faLock} /></span>
						<p className="eyebrow">SECURE ACCESS</p>
						<h2>Welcome back</h2>
						<p>Sign in with your Domus IoT credentials.</p>
					</div>

					<form className="login-form" onSubmit={handleSubmit}>
						<label htmlFor="username">Username</label>
						<div className="login-input">
							<FontAwesomeIcon icon={faUser} aria-hidden="true" />
							<input
								id="username"
								name="username"
								type="text"
								autoComplete="username"
								value={username}
								onChange={(event) => setUsername(event.target.value)}
								placeholder="name.surname"
								disabled={isSubmitting}
								required
							/>
						</div>

						<label htmlFor="password">Password</label>
						<div className="login-input">
							<FontAwesomeIcon icon={faLock} aria-hidden="true" />
							<input
								id="password"
								name="password"
								type="password"
								autoComplete="current-password"
								value={password}
								onChange={(event) => setPassword(event.target.value)}
								placeholder="Enter your password"
								disabled={isSubmitting}
								required
							/>
						</div>

						<button className="login-submit" type="submit" disabled={isSubmitting}>
							<span>{isSubmitting ? "Signing in…" : "Sign in"}</span>
							<FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
						</button>
					</form>

					<p className="login-help">
						Access is managed by the Domus IoT platform administrator.
					</p>
				</div>
			</section>
		</main>
	);
};

export default Login;
